import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';

function SelectionDashboard() {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/login');
    } catch (error) {
      console.error("Error signing out: ", error);
      alert("Failed to sign out.");
    }
  };

  // --- STYLES ---
  const wrapperStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '40px 20px',
  };

  const headerStyle = {
    marginBottom: '40px',
  };

  const selectionContainerStyle = {
    display: 'flex',
    gap: '30px',
    justifyContent: 'center',
    flexWrap: 'wrap',
  };

  const cardStyle = {
    backgroundColor: '#ffffff',
    border: '1px solid #dee2e6',
    borderRadius: '8px',
    padding: '40px',
    width: '300px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.07)',
    textDecoration: 'none',
    color: '#333',
    transition: 'transform 0.2s, box-shadow 0.2s',
  };
  
  const cardHoverStyle = {
    transform: 'translateY(-5px)',
    boxShadow: '0 8px 16px rgba(0,0,0,0.1)',
  };

  const logoutButtonStyle = {
    marginTop: '50px',
    padding: '10px 20px',
    backgroundColor: '#dc3545',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontWeight: '600',
  };

  return (
    <div style={wrapperStyle}>
      <header style={headerStyle}>
        <h1>Welcome</h1>
        <p style={{ color: '#6c757d' }}>Please select a database to continue.</p>
      </header>

      <div style={selectionContainerStyle}>
        <Link 
          to="/coa-home" 
          style={cardStyle}
          onMouseOver={e => e.currentTarget.style = {...cardStyle, ...cardHoverStyle}}
          onMouseOut={e => e.currentTarget.style = cardStyle}
        >
          <h2>COA Database</h2>
          <p>Manage Certificate of Analysis, products, and customers.</p>
        </Link>
        <Link 
          to="/hrm-home" 
          style={cardStyle}
          onMouseOver={e => e.currentTarget.style = {...cardStyle, ...cardHoverStyle}}
          onMouseOut={e => e.currentTarget.style = cardStyle}
        >
          <h2>HRM Database</h2>
          <p>Manage employee attendance, reports, and analytics.</p>
        </Link>
      </div>
      
      <button 
        onClick={handleLogout} 
        style={logoutButtonStyle}
      >
        Logout
      </button>
    </div>
  );
}

export default SelectionDashboard;